<template>
  <div>
    <confirm-cancel-reference-book-dialog :cancelAddOn.sync="cancelAddOn" />
    <!-- Premium Content -->
    <template v-if="addOns && addOns[addOnType].length">
      <template v-for="(item, index) in addOns[addOnType]">
        <template v-if="item.name !== 'Extended Warranty'">
          <v-layout :key="`${index}-addOn`" column align-center class="mb-2">
            <v-flex class="txt-bold mb-2" style="font-size: 18px">{{ item.name }}</v-flex>
            <v-flex class="pl-4 pr-4 mb-3 text-xs-center" style="font-size: 15px">{{ item.description }}</v-flex>
            <v-flex class="txt-bold text-xs-center itoviPurple--text mb-2">
              ${{ formatPrice(monthlyTab ? item.monthly : item.yearly) }}{{`${monthlyTab ? "/month" : "/year"}`}}
            </v-flex>
            <v-flex class="text-xs-center">
              <template v-if="addOnType === 'available'">
                <button class="button-gray-disabled" v-if="inCart(item.id)">
                  IN THE CART
                </button>
                <button class="button-purple" v-else @click="addToCart(item, !monthlyTab)">
                  ADD TO CART
                </button>
              </template>
              <template v-if="addOnType === 'applied'">
                <button class="button-purple" v-if="item.status === 'pending_cancel' && monthlyTab === !item.is_yearly" @click="reactivateAddOn(item.id)">
                  RESUBSCRIBE
                </button>
                <button class="button-gray" v-else-if="item.status === 'active' && monthlyTab === !item.is_yearly" @click="unsubscribe(item)">
                  UNSUBSCRIBE
                </button>
                <p class="mb-0 itoviPurple--text" style="font-size: 14px; font-weight: 600;" v-else >{{item.is_yearly ? 'Annual' : 'Monthly'}} subscription currently active</p>
              </template>
              <p class="mb-0" style="font-size: 10px; color: #999999;" v-if="inCart(item.id) === 'annually'">annual subscription in the cart</p>
              <p class="mb-0" style="font-size: 10px; color: #999999;" v-if="inCart(item.id) === 'monthly'">monthly subscription in the cart</p>
            </v-flex>
          </v-layout>
          <v-divider :key="`${index}-addOn-divider`" class="mt-4 mb-4"/>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
  import store from "@/store";
  import api from "@/services/api_endpoints"
  import ConfirmCancelReferenceBookDialog from "@/components/dashboard/yourPlanCard/ConfirmCancelReferenceBookDialog";
  import { formatPrice } from "@/helpers/priceHelper";
  import subscribeToStore from "@/mixins/subscribeToStore";

  export default {
    components: {
      ConfirmCancelReferenceBookDialog
    },
    props: {
      monthlyTab: {
        type: Boolean,
        default: true
      },
      addOnType: {
        type: String,
        default: 'available'
      }
    },
    mixins: [subscribeToStore],
    data() {
      return {
        addOns: store.state.addOns,
        cancelAddOn: {
          show: false,
          addOn: {}
        },
        referenceBookCart: store.state.referenceBookCart
      }
    },
    mounted() {
      this.subscribeToStore(['addOns', 'referenceBookCart']);
    },
    methods: {
      formatPrice,
      addToCart(item, annually = false) {
        this.referenceBookCart.push({...item, inCart: annually ? "annually" : "monthly"});
        store.commit('setReferenceBookCart', this.referenceBookCart);
      },
      inCart(id) {
        const item =this.referenceBookCart.filter((item) => item.id === id)[0];
        if(!item) return null;
        return item.inCart;
      },
      unsubscribe(addOn) {
        this.cancelAddOn = {
          show: true,
          addOn: addOn
        };
      },
      async reactivateAddOn(id) {
        const result = await api.reactivateAddOn(id);
        await api.getPlanAddOns();
        console.log(result);
      }
    }
  }
</script>